<template>
  <div>
    <section class="main" v-if="IsLoaded && QRCodeData.Ticket != null">
      <div class="container">
        <div class="box">
          <h2 class="">
            {{ $t("使用中QR Code") }}
            <span>{{ QRCodeData.Product.Time }}{{ $t("小時") }}</span>
          </h2>
          <hr />
          <div class="time-box">
            <p>{{ $t("剩餘時間") }}</p>
            <p class="time">{{ Reciprocal }}</p>
          </div>
          <div
            class="red-text"
            v-if="QRCodeData.Ticket.IsUsing && QRCodeData.Ticket.IsExpired"
          >
            <p>{{ $t("僅可出站/下車") }}</p>
          </div>
          <div class="qr-box">
            <img :src="'data:image/jpeg;base64,' + QRCodeData.QRCode" alt="" />
            <p class="">{{ RefashTime }}{{ $t("秒後更新") }}</p>
          </div>
        </div>
        <hr />
        <div class="box">
          <h2 class="">{{ $t("詳細資訊") }}</h2>
          <hr />
          <ul class="text-box">
            <li>
              <div>YouBike</div>
              <div>
                <p
                  v-clipboard:copy="QRCodeData.Ticket.voucher_uuid"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                >
                  {{ QRCodeData.Ticket.voucher_uuid }}
                </p>
                <p class="btn">{{ $t("點選序號進行複製") }}</p>
              </div>
            </li>
            <hr />
            <li>
              <div>{{ $t("起始時間") }}</div>
              <div class="red-color">{{ QRCodeData.StartTime }}</div>
            </li>
            <hr v-if="false" />
            <li v-if="false">
              <div>{{ $t("渡輪次數") }}</div>
              <div>{{ QRCodeData.Ferry }}{{ $t("次") }}</div>
            </li>
            <hr />
            <li>
              <div>QR No.</div>
              <div>
                <p>{{ QRCodeData.Ticket.CardId }}</p>
                <router-link
                  :to="{
                    name: 'TicketLog',
                    params: { TId: QRCodeData.Ticket.TId },
                  }"
                  tag="p"
                  class="btn"
                >
                  {{ $t("搭乘紀錄") }}
                </router-link>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>
    <!-- 減碳足跡 -->
    <!-- <section class="carbon-footprint">

                <div class="container">
                    <div class="carbon-box">
                        <p>減碳 100克</p>
                        <img src="./img/doll-2.png" alt="">
                    </div>
                </div>

            </section> -->

    <!-- 底部加高 底部固定選單fixed的高度 -->
    <div class="nav-menu-bg"></div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import AES from "@/utils/aes.js";
import CountDown from "@/utils/countdown.js";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import VueClipboard from "vue-clipboard2";
import VueI18n from "vue-i18n";
import Storage from "@/utils/storage.js";

Vue.use(VueAxios, axios);
Vue.use(VueSweetalert2);
Vue.use(VueClipboard);
Vue.use(VueI18n);

// this.$t("立即購買")
const messages = {
    zh_tw: {
    "使用中 QR Code": "使用中 QR Code",
    "小時": "小時",
    "剩餘時間": "剩餘時間",
    "僅可出站/下車": "僅可出站/下車",
    "秒後更新": "秒後更新",
    "詳細資訊": "詳細資訊",
    "點選序號進行複製": "點選序號進行複製",
    "起始時間": "起始時間",
    "渡輪次數": "渡輪次數",
    "次": "次",
    "搭乘紀錄": "搭乘紀錄",
    "錯誤": "錯誤",
    "取得QRCode發生錯誤, 請稍後再試一次": "取得QRCode發生錯誤, 請稍後再試一次",
    "確定": "確定",
    "複製成功": "複製成功",
    "是否立刻前往兌換說明頁面進行兌換?": "是否立刻前往兌換說明頁面進行兌換?",
    "是": "是",
    "否": "否",
    "序號複製失敗, 請稍後再試一次": "序號複製失敗, 請稍後再試一次",
  },
  en: {
    "使用中 QR Code": "QR Code in use",
    "小時": "Hour",
    "剩餘時間": "Remaining time",
    "僅可出站/下車": "For exit only",
    "秒後更新": "Update after...seconds",
    "詳細資訊": "Detailed info",
    "點選序號進行複製": "Click the number to copy",
    "起始時間": "Start time",
    "渡輪次數": "Rounds of ferry",
    "次": "Trip",
    "搭乘紀錄": "Transportation record",
    "錯誤": "Error",
    "取得QRCode發生錯誤, 請稍後再試一次": "Error. Please try again.",
    "確定": "Confirm",
    "複製成功": "Copied",
    "是否立刻前往兌換說明頁面進行兌換?": "Do you want to go to the redemption instructions page?",
    "是": "Yes",
    "否": "No",
    "序號複製失敗, 請稍後再試一次": "Failed to copy the number. Please try again.",
  },
  jp: {
    "使用中 QR Code": "QRコード使用中",
    "小時": "時間",
    "剩餘時間": "残り時間",
    "僅可出站/下車": "退場/降車のみできます",
    "秒後更新": "ー秒後更新",
    "詳細資訊": "詳細情報",
    "點選序號進行複製": "コピーするクーポン番号をクリックする",
    "起始時間": "開始時間",
    "渡輪次數": "渡輪次數",
    "次": "次",
    "搭乘紀錄": "利用履歴",
    "錯誤": "エラー",
    "取得QRCode發生錯誤, 請稍後再試一次": "QRコード取得中にエラーが発生しました,時間をおいてから再度お試しください",
    "確定": "確定",
    "複製成功": "コピーに成功しました",
    "是否立刻前往兌換說明頁面進行兌換?": "引き換え説明ページに移動して、すぐに引き換えますか",
    "是": "はい",
    "否": "いいえ",
    "序號複製失敗, 請稍後再試一次": "クーポン番号のコピーに失敗しました,時間をおいてから再度お試しください",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

export default {
  name: "QRCode",
  i18n,
  data() {
    return {
      QRCodeData: {},
      RefashTime: 300,
      Init: false,
      IsLoaded: false,
      Reciprocal: "",
    };
  },
  created: function () {
    this.renewQRCode();
  },
  updated: function () {},
  mounted: function () {
    // 回頂端
    $(window).scrollTop(0);
    // 套用Class
    $(".wrapper").addClass("qrcode-main");
    // i18n
    if (Storage.isKey("ek_site_lang")) {
      i18n.locale = Storage.get("ek_site_lang");
    } else {
      i18n.locale = "zh_tw";
    }
  },
  methods: {
    renewQRCode() {
      let that = this;
      // 第一次進入時清空
      if (Storage.isKey("needReloadQRCode")) {
        Storage.remove("needReloadQRCode");
      }
      $.ajax({
        url: that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/QRCode",
        //url: "https://localhost:44321/Html/QRCode",
        type: "post",
        data: {
          token: Storage.get("ek_login_token"),
        },
        dataType: "json",
        error: function () {
          that.$swal({
            heightAuto: false,
            title: that.$t("錯誤"),
            text: that.$t("取得QRCode發生錯誤, 請稍後再試一次"),
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: that.$t("確定"),
          });
        },
        success: function (res) {
          // 判斷結果
          if (res.ok) {
            that.QRCodeData = JSON.parse(res.data);
            that.RefashTime = 300;
            var loop = window.setInterval(function () {
              that.RefashTime -= 1;
              if (that.RefashTime == 0 || Storage.isKey("needReloadQRCode")) {
                window.clearInterval(loop);
                that.renewQRCode();
              }
              // 倒數
              let rest = CountDown.countdown(
                that.QRCodeData.EndTime_Y,
                that.QRCodeData.EndTime_M,
                that.QRCodeData.EndTime_D,
                that.QRCodeData.EndTime_H,
                that.QRCodeData.EndTime_MM,
                that.QRCodeData.EndTime_S,
                that.QRCodeData.Product.Time
              );
              that.Reciprocal =
                rest[0] + ":" + rest[1] + ":" + rest[2] + ":" + rest[3];
            }, 1000);
          } else if (res.error_msg) {
            var error_msg = JSON.parse(res.error_msg);
            if (res.toekn_error) {
              that.$swal({
                heightAuto: false,
                title: that.$t("錯誤"),
                text: error_msg[i18n.locale],
                icon: "error",
                allowOutsideClick: false,
                willClose: function () {
                  // 移除登入資訊
                  Storage.remove("ek_login_token");
                  // 回到首頁
                  that.$router.push({
                    name: "Home",
                    params: {},
                  });
                },
              });
            } else {
              // that.$swal({
              //   heightAuto: false,
              //   title: that.$t("錯誤"),
              //   text: i18n.locale == "en" ? res.error_en : res.error,
              //   icon: "error",
              //   allowOutsideClick: false,
              //   confirmButtonText: that.$t("確定"),
              // });
              that
                .$swal({
                  heightAuto: false,
                  title: that.$t("錯誤"),
                  html: error_msg[i18n.locale],
                  allowOutsideClick: false,
                  confirmButtonText: that.$t("前往訂單"),
                  showCancelButton: true,
                  cancelButtonText: that.$t("回首頁"),
                })
                .then((result) => {
                  console.log(result);
                  if (result.isConfirmed) {
                    // 轉到首頁
                    that.$router.push({
                      name: "OrderInfo",
                      params: { OrderId: res.OrderId },
                    });
                  } else {
                    that.$router.push({
                      name: "Home"
                    });
                  }
                });
            }
          }
          // 設為已載入
          that.IsLoaded = true;
        },
      });
    },
    onCopy(e) {
      let that = this;
      Storage.set("voucher_uuid", e.text, "1d");
      Storage.set("voucher_url", this.QRCodeData.Ticket.voucher_url, "1d");
      this.$swal({
        heightAuto: false,
        title: this.$t("複製成功"),
        text: this.$t("是否立刻前往兌換說明頁面進行兌換?"),
        icon: "success",
        allowOutsideClick: false,
        confirmButtonText: this.$t("是"),
        showCancelButton: true,
        cancelButtonText: this.$t("否"),
      }).then((result) => {
        if (result.isConfirmed) {
          if (i18n.locale == "jp") {
            that.$router.push({
              name: "Post",
              params: { PId: 599 },
            });
          } else {
            that.$router.push({
              name: "Post",
              params: { PId: 35 },
            });
          }
        }
      });
    },
    onError(e) {
      alert(this.$t("序號複製失敗, 請稍後再試一次"));
    },
    gotoTicketLog(TId) {
      this.$router.push({
        name: "TicketLog",
        params: { TId: TId },
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.order-3 .single-item img {
  margin-bottom: 60px;
  filter: blur(0px) opacity(1);
}
.order-2 .box .no1 .color-g {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/QRCode.vue